import { Fragment } from "react";
import { ErrorBoundary } from "src/components/ErrorBoundary/ErrorBoundary";
import DOMPurify from 'dompurify';

export const QuoteGeneralInfo = (props: { generalInfo: string }) => {
  const { generalInfo } = props;

  return (
    <Fragment>
      <ErrorBoundary>
        <div className="quote-head-container quote-coverpage-elem break-before">
          <div
              className="general-info"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(generalInfo) }}
          />
        </div>
      </ErrorBoundary>
    </Fragment>
  );
};
